<template>
  <div>
    <v-subheader v-if="filteredEvents && filteredEvents.length > 0">Google meeting info
      <v-spacer/>
      <span v-if="calendarOwningCourses && calendarOwningCourses.id">Using calendar from <v-chip outlined small :to="{path: `/secure/course/${calendarOwningCourses.id}`}">{{calendarOwningCourses.name}}</v-chip></span>
      <v-bottom-sheet v-if="calendarSharingCourses && calendarSharingCourses.length > 0">
        <template v-slot:activator="{ on, attrs }">
            <v-chip outlined v-bind="attrs" v-on="on">
              {{calendarSharingCourses.length}} {{calendarSharingCourses.length > 1 ? 'courses':'course'}} sharing this calendar 

            </v-chip>
        </template>
            <v-sheet class="text-center" height="100px">
                <div style="overflow-x: scroll; white-space: nowrap;">
              <span :key="c.id" v-for="c in calendarSharingCourses">
                <v-chip :to="`/secure/course/${c.id}`" class="ma-5" outlined>{{c.name}}</v-chip>
              </span>
                </div>
            </v-sheet>
      </v-bottom-sheet>
    </v-subheader>
    <v-expansion-panels>
      <v-expansion-panel v-for="( event ) in filteredEvents" :key="event.id">
        <v-expansion-panel-header>
          <span>
          <v-btn v-if="editable" @click="deleteEvent(event)" :disabled="isAppLoading" icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          {{event.summary}}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" lg="4">
              <v-list-item-title>
                <strong>{{event.summary}}</strong>
                <v-chip outlined class="ml-5" :href="event.htmlLink" target="_blank">
                  <v-icon class="mr-2">mdi-calendar</v-icon>View in Google Calendar
                </v-chip>
              </v-list-item-title>
              <div class="mt-5" v-if="event.recurrence && event.recurrence.length > 0">
                <span v-html="rRuleToText(event)"></span>
                {{event.description}}
                <!-- <div class="ml-5" v-for="(d) in parseRRuleFromEvent(event)" :key="d.toString()">
            <br />
            {{d}}
                </div>-->
              </div>
              <span
                v-else
              >{{formatDate(event.start.dateTime, 'date time')}} - {{formatDate(event.end.dateTime, 'date time')}}</span>

              <!-- Canceled events -->
              <div class="mt-5">
                Canceled Events:
                <ul class="mt-3">
                  <li
                    v-for=" (event) in canceledEvents"
                    :key="event.id"
                  >{{formatDate(event.originalStartTime.dateTime, 'date time')}}</li>
                </ul>
              </div>

              <!-- Reminders set for this event -->
              <div class="mt-5">
                Scheduled Reminders:
                <ul class="mt-3">
                  <li
                    v-for=" (reminder) in event.reminders.overrides"
                    :key="reminder.minutes"
                  >{{reminder.method}} {{formatMinutes(reminder.minutes)}} prior</li>
                </ul>
              </div>
            </v-col>

            <v-col cols="12" lg="4">
              <v-list-item-title>
                <strong>Conference Info</strong>
              </v-list-item-title>
              <div class="mt-5">Meeing Code: {{event.conferenceData.conferenceId}}</div>
              <div class="my-5" v-for=" entry in event.conferenceData.entryPoints" :key="entry.uri">
                <template v-if="entry.entryPointType != 'more'">
                  <span class="group">
                    <v-icon>{{entry.entryPointType == 'video' ? 'mdi-video':'mdi-phone'}}</v-icon>
                    {{entry.entryPointType}}
                  </span>
                  <br />
                  <div class="mt-3">
                    <a :href="entry.uri">{{entry.label}}</a>
                    <br />
                    <template v-if="entry.pin">
                      Pin: {{entry.pin}}
                      <br />
                    </template>
                  </div>
                </template>
              </div>
            </v-col>

            <v-col v-if="event.attendees && event.attendees.length > 0" cols="12" lg="4">
              <v-list-item-title>Attendees</v-list-item-title>
              <ul class="mt-5">
                <li v-for=" (attendee) in event.attendees" :key="attendee.id">
                  <template v-if="attendee.name">{{attendee.name}} -</template>
                  {{attendee.email}} ({{attendee.responseStatus}})
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { rrulestr } from "rrule";

export default {
  props: ["events", "course", "editable"],
  data() {
    return {
      eventTitle: "",
      eventDescription: "",
      dayOfWeeks: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      selectedDow: "Monday",
      calendarOwningCourses: {},
      calendarSharingCourses: []
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    filteredEvents: function() {
      return this.events.filter(
        e => e.recurringEventId == null && e.status !== "cancelled"
      );
    },
    canceledEvents: function() {
      return this.events.filter(
        e => e.recurringEventId != null && e.status === "cancelled"
      );
    },
    eventDates: function() {
      if (this.course.courseSchedules) {
        return this.course.courseSchedules.map(cs => {
          return {
            id: cs.id,
            start: moment(cs.start).format("YYYY-MM-DD"),
            end: moment(cs.end),
            dow: cs.dow
          };
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    deleteEvent(event) {
      const deleteRequest = {
        eventId: event.id,
        calendar: this.course.calendarId,
        googleCourseId: this.course.googleCourseId
      };
      this.$axios
        .post("/classroom/course/delete/event", deleteRequest)
        .then(resp => {
          const modifiedCourse = resp.data;
          const deletedId = event.id;
          this.events.splice(
            this.events.findIndex(e => e.id == deletedId),
            1
          );
          this.course.scheduleStart = modifiedCourse.scheduleStart;
          this.course.scheduleEnd = modifiedCourse.scheduleEnd;
        })
        .catch(err => {
          this.$store.dispatch("addMessage", {
            message: err.data,
            messageClass: "danger"
          });
        });
    },
    formatDate(dateTime, mode) {
      if (mode === "time") {
        return new moment(dateTime.value).format("h:mm a");
      } else if (mode === "date time") {
        return new moment(dateTime.value).format("MMM DD, YYYY h:mm a");
      } else if (mode === "date time with dow") {
        return new moment(dateTime.value).format("ddd MMM DD, YYYY h:mm a");
      } else if (mode === "date") {
        return new moment(dateTime.value).format("MMM DD, YYYY");
      } else if (mode === "date with dow") {
        return new moment(dateTime.value).format("ddd MMM DD, YYYY");
      } else if (mode === "dow") {
        return new moment(dateTime.value).format("dddd");
      }
    },
    compareTimeString(time1, time2) {
      const startTime = moment(time1, "HH:mm");
      const endTime = moment(time2, "HH:mm");
      const isAfter = endTime.isAfter(startTime);
      return isAfter;
    },
    parseRRuleFromEvent(event) {
      const dtStartUTC = moment(event.start.dateTime.value).utc();
      const dtStartRRuleFormat = dtStartUTC.format("YYYYMMDDTHHMMSS[Z]");
      if (event.recurrence && event.recurrence) {
        const rrule = event.recurrence[0];
        const rule = rrulestr(`DTSTART:${dtStartRRuleFormat}\n${rrule}`);
        return rule.all(function (date, i){return i < 300});
      }
      return [];
    },
    rRuleToText(event) {
      const startDate = this.formatDate(event.start.dateTime, "date with dow");
      const startTime = this.formatDate(event.start.dateTime, "time");
      const endTime = this.formatDate(event.end.dateTime, "time");
      if (event.recurrence && event.recurrence) {
        const rrule = event.recurrence[0];
        const rule = rrulestr(rrule);
        const ruleText = rule.toText();
        return `Starts ${startDate} from ${startTime}-${endTime},<br/> ${ruleText}`;
      } else {
        return this.formatDate(event.end, "date");
      }
    },
    formatMinutes(mins) {
      const days = Math.floor(mins / (60 * 24));
      const hours = Math.floor(mins / 60);
      const minutes = mins % 60;
      const text =
        (days > 0 ? days + " days" : "") +
        (hours % 24 > 0 ? (hours % 24) + " hours" : "") +
        (minutes > 0 ? minutes + " minutes" : "");
      return text;
    },
    findCalendarOwner(){
      //find owner of alternative calendar
      if(this.course.alternativeCalendarId) {
        const params = { calendarId: this.course.alternativeCalendarId }
        this.$axios.get('/course/calendar/lookup-owner', {params})
          .then( resp => {
            if(resp.data){
              if(resp.data.data && resp.data.data.length > 0){
                this.calendarOwningCourses = resp.data.data[0];
              }
            }
          })
          .catch( error => {
            this.addErrorMessage(error.message);
          })
      }
    },
    findCalendarShared(){
      //find owner of alternative calendar
      if(this.course.calendarId) {
        const params = { calendarId: this.course.calendarId }
        this.$axios.get('/course/calendar/lookup-shared', {params})
          .then( resp => {
            if(resp.data){
              if(resp.data.data && resp.data.data.length > 0){
                this.calendarSharingCourses = resp.data.data;
              }
            }
          })
          .catch( error => {
            this.addErrorMessage(error.message);
          })
      }
    }
  },
  mounted() {
    this.findCalendarOwner();
    this.findCalendarShared();
  }
};
</script>

<style>
</style>